import type { StoreActionApi } from 'react-sweet-state';
import { initialState } from '../config';
import type { State } from '../types';

const actions = {
	setMediaHeight:
		(mediaId: string, height: number) =>
		({ setState }: StoreActionApi<State>) => {
			setState({
				[mediaId]: {
					height,
				},
			});
		},
	clearCardMedia:
		() =>
		({ setState }: StoreActionApi<State>) =>
			setState(initialState),
} as const;

export type Actions = typeof actions;
export default actions;
